import { Box, Typography, TypographyProps } from "@mui/material";
import { PropsWithoutRef } from "react";

type IProps = PropsWithoutRef<
	TypographyProps & {
		color?: string;
		htmlContent: string;
		maxlines?: number;
		spacing?: number;
	}
>;

const HtmlDescription = (props: IProps) => {
	const {
		fontSize = 20,
		color = "black",
		htmlContent,
		maxlines,
		spacing = 0,
	} = props;

	return (
		<Typography
			{...props}
			color={color}
			fontSize={fontSize}
			align={props.align}
			className={"label"}
			style={{
				overflow: "hidden",
				textOverflow: maxlines ? "unset" : "ellipsis",
				display: "-webkit-box",
				WebkitBoxOrient: "vertical",
				WebkitLineClamp: maxlines,
				marginBlock: `${spacing}px`,
			}}
		>
			<Box
				dangerouslySetInnerHTML={{ __html: htmlContent }}
				style={{
					overflow: "hidden",
					textOverflow: "ellipsis",
					display: "-webkit-box",
					WebkitBoxOrient: "vertical",
					WebkitLineClamp: maxlines,
				}}
			></Box>
		</Typography>
	);
};

export default HtmlDescription;
